import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, inject, Inject, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { COMMON_MODULES, ROUTES } from '@src/app/core/constants';
import { LocalStorageService, SharedDataService, HelperService } from '@src/app/core/services';
import { StorageService } from '@src/app/core/services/storage.service';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { environment } from '@src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-memberportal-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  imports: [
    ...COMMON_MODULES,
    CommonModule,

  ],
  styleUrl: './navbar.component.scss'
})
export class MemberPortalNavbarComponent {
  public routes = ROUTES
  public user: any;
  environment = environment
  localStorageService = inject(LocalStorageService)
  sharedService = inject(SharedDataService)
  isUser: boolean = false
  isLoginPage: boolean = false;
  isRegisterPage: boolean = false;
  currentRoute: any = '';
  helperService = inject(HelperService)
  storageService = inject(StorageService)
  //Warning error variables
  showFutureServiceErr = false;
  headerPhoneNumber = "";
  forcesDefaultLoginLogos : boolean = false;
  hasWellnessMembership : boolean = false;
  isMemberPortalOnly = environment.memberPortalOnly

  errMsg = 'some msg';
  containerStyle = 'padding: 0';
  msgBodyStyle = 'border-radius: 0'
  isMiniEnv = false
  isnavbar = false;
  logoIcon: string = '';
  headerLogoTransparent = "";
  logoIconMobile: string = '';
  iconWidth: number = 168
  iconWidthMobile: number = 100
  @Output() navbarChange: EventEmitter<boolean> = new EventEmitter();
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public sharedDataService: SharedDataService,
    private translate: TranslateService,
    private store: Store
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd && this.currentRoute !== event.url) {
          this.currentRoute = event.url;
          this.shouldShowMenu(event.urlAfterRedirects || event.url);
        }
      });

    this.shouldShowMenu(window.location.href);
  }
  private miniEnvCheck() {
    this.isMiniEnv = this.store.snapshot().appMode.isMiniEnv;
    if (this.isMiniEnv) {
      const miniEnvConfig = this.storageService.getMiniEnvConfig();
      const config = this.storageService.getAppModel()?.envConfig || miniEnvConfig;
      const hasToken = this.storageService.getUserInformation();

      // If user is logged in and the mini-env config allows login-specific logos, use them.
      if (hasToken && !config?.forcesDefaultLoginLogos) {
          this.logoIcon = config?.headerDesktopLogologin || miniEnvConfig?.headerDesktopLogo || this.sharedService.imagesUrl + 'logo.svg';
          this.logoIconMobile = config?.headerMobileLogoLogin || miniEnvConfig?.headerMobileLogo || this.sharedService.imagesUrl + 'logo-mobile.svg';
          this.iconWidth = config?.headerLogoWidthLogin || miniEnvConfig?.headerLogoWidth || 168;
          this.iconWidthMobile = config?.headerLogoWidthMobLogin || miniEnvConfig?.headerLogoWidthMob || 100;
          this.headerPhoneNumber = config?.headerPhoneNumber || miniEnvConfig?.headerPhoneNumber || '';
      } else {
        // Default mini-env logos
          this.logoIcon = miniEnvConfig?.headerDesktopLogo || this.sharedService.imagesUrl + 'logo.svg';
          this.logoIconMobile = miniEnvConfig?.headerMobileLogo || this.sharedService.imagesUrl + 'logo-mobile.svg';
          this.iconWidth = miniEnvConfig?.headerLogoWidth || 168;
          this.iconWidthMobile = miniEnvConfig?.headerLogoWidthMob || 100;
          this.headerPhoneNumber = miniEnvConfig?.headerPhoneNumber || '';
      }
    }
    else {
      this.logoIcon = this.sharedService.imagesUrl + "logo.svg";
      this.logoIconMobile = this.sharedService.imagesUrl + "logo-mobile.svg";
      if (environment?.navbarConfig) {
        this.iconWidth = environment.navbarConfig.iconWidth || this.iconWidth;
        this.iconWidthMobile = environment.navbarConfig.iconWidthMobile || this.iconWidthMobile;
      }
    }
  }
  private shouldShowMenu(url: string): void {
    // Implement your logic to determine when to show/hide the menu based on the route
    // For example, you can check if the route is '/login' or '/dashboard'
    this.isUser = this.storageService.getUserInformation() ? true : false
    this.isLoginPage = url.includes('/login');
    this.isRegisterPage = url.includes('/register');
    this.isRegisterPage = url.includes('/reset-password');
    if (url.includes('/forgot')) {
      this.isRegisterPage = url.includes('/forgot');
    }
  }
  ngOnInit(): void {
    $('body').removeClass('minienv-landingpage-body');
    console.log("is webview check", this.sharedDataService.isAppWebView)
    this.hasWellnessMembership = localStorage.getItem('hasWellnessMembership') === 'true';
    this.user = this.storageService.getUserInformation()
    this.loadLanguage();
    this.miniEnvCheck()
  }
  get userInitials(): string {
    const firstInitial = this.user.firstName?.charAt(0).toUpperCase() || '';
    const lastInitial = this.user.lastName?.charAt(0).toUpperCase() || '';
    return `${firstInitial}${lastInitial}`;
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  hideError(e: any) {
    this.showFutureServiceErr = false;
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.removeItem('isLoggedin');

    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth/login']);
    }
  }

  toggleNavbar() {
    this.isnavbar = !this.isnavbar;
    this.navbarChange.emit(this.isnavbar);

  }

  navclose() {
    this.isnavbar = false;
    this.navbarChange.emit(this.isnavbar);

  }
  currentLanguage: string = 'en';
  public setLanguage(event: any) {
    const ln = event;
    const lang = { code: ln };
    this.currentLanguage = ln;
    this.localStorageService.setDataInLocalStorage({ key: 'language', value: lang }, false);
    this.reloadCurrentRoute();
    this.sharedService.setUserLanguage(ln);
    this.sharedService.setAppConfig();
    console.log(ln, 'selected language');
    this.sharedService.currentLanguage = ln;
  }
  reloadCurrentRoute() {
    // const currentUrl = this.router.url;
    // this.router
    //   .navigateByUrl(ROUTES.resolver, { skipLocationChange: true })
    //   .then(() => this.router.navigateByUrl(currentUrl));
    window.location.reload();
  }
  loadLanguage() {
    const storedLang = this.localStorageService.getDataInLocalStorage('language', false);
    const ln = storedLang ? storedLang.code : 'en';
    this.currentLanguage = ln;
    this.translate.setDefaultLang('en');
    this.translate.use(ln);
    console.log(this.currentLanguage, 'current language in load language');
  }
  changeTopBar()
  {
    this.localStorageService.setDataInLocalStorage({ key: 'topbar', value: '"WEBSITE"' });
    window.location.href = this.routes.home;
  }
}
